import { render, staticRenderFns } from "./user.vue?vue&type=template&id=1f7cd5d4&scoped=true&"
import script from "./user.vue?vue&type=script&lang=js&"
export * from "./user.vue?vue&type=script&lang=js&"
import style0 from "./user.vue?vue&type=style&index=0&id=1f7cd5d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7cd5d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f7cd5d4')) {
      api.createRecord('1f7cd5d4', component.options)
    } else {
      api.reload('1f7cd5d4', component.options)
    }
    module.hot.accept("./user.vue?vue&type=template&id=1f7cd5d4&scoped=true&", function () {
      api.rerender('1f7cd5d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ecommerce/user.vue"
export default component.exports